import GroupSummary from "../js/components/dashboard/GroupSummary.react";
export default GroupSummary;
